import React from "react";
import {Navigate, useRoutes} from "react-router";
import ListOfIntCollRequests from "../features/collection-requests/ListOfIntCollRequests";
import ListOfExperts from "../features/experts/ListOfExperts.jsx";
import ExpertPage from "../features/experts/ExpertPage";
import ReportEditorPage from "../features/products/reportEditorPage/ReportEditorPage";
import ReportMentionsPage from "../features/products/reportMentionsPage/ReportMentionsPage";
import AppAnalyst from "../apps/analyst/appAnalyst";
import AnalyticsPage from "../apps/manager/pages/analytics/AnalyticsPage";
import ReportPreviewPage from "../features/products/previewPage/ReportPreviewPage";
import {ReportPageLayout} from "../features/products/reportPage";
import IcrPage from "../features/collection-requests/IcrPage";
import NewIcrPage from "../features/collection-requests/NewIcrPage";
import EeiPage from "../features/collection-requests/EeiPage";
import GapPage from "../features/collection-requests/GapPage";
import {routesChat} from "./routesChat";
import FeedsPage from "../features/chat/feeds/FeedsPage";
import FeedItems from "../features/chat/feeds/components/FeedItems";
import ReadbookPage from "../apps/policymaker/pages/readbooks/ReadbookPage";
import AllProductsPage from "../features/products/pages/AllProductsPage";
import KnowledgeBasePage from "../features/knowledgeBase/KnowledgeBasePage";
import EntitiesList from "../features/knowledgeBase/EntitiesList";
import EntityDetailPage from "../features/knowledgeBase/EntityDetailPage";
import WhiteboardsListPage from "../features/whiteboards/WhiteboardsListPage";
import WhiteboardPage from "../features/whiteboards/WhiteboardPage";
import WorkflowPage from "../features/workflow/WorkflowPage";
import HelpPage from "../features/help/HelpPage";
import LegacyRfiRedirect from "./LegacyRfiRedirect";
import LegacyWhiteboardRedirect from "./LegacyWhiteboardRedirect";
import TagBrowsePage from "../features/collection-requests/tags/TagBrowsePage";
import {collectionChildRoutes, collectionDeepLinkRoutes} from "./collectionRoutes";
import {useSession} from "../firebase/UserProvider";
import {canAccessCollectionTab} from "../features/collection/collectionTaskPayload";

const buildRoutesAnalyst = (collectionRoutes) => [
    ...routesChat,
    {
        path: "/",
        element: <AppAnalyst/>,
        children: [
            {index: true, element: <Navigate to="products" replace/>},
            {path: "analytics", element: <AnalyticsPage/>},
            {path: "workflow", element: <WorkflowPage/>},
            {path: "/icr/eei/:eeiNumber", element: <EeiPage/>},
            {path: "/icr/gap/:gapNumber", element: <GapPage/>},
            {path: "/icr/new", element: <NewIcrPage/>},
            {path: "/icr/:icrNumber", element: <IcrPage/>},
            {path: "/icr", element: <ListOfIntCollRequests/>},
            {path: "/tags/:tag", element: <TagBrowsePage/>},
            {path: "/rfi", element: <Navigate to="/icr" replace/>},
            {path: "/rfi/*", element: <LegacyRfiRedirect/>},
            ...collectionRoutes,
            {path: "products", element: <AllProductsPage/>},
            {path: "experts", element: <ListOfExperts/>},
            {path: "experts/:handle", element: <ExpertPage/>},
            {path: "charts", element: <WhiteboardsListPage/>},
            {
                path: "kb",
                element: <KnowledgeBasePage/>,
                children: [
                    {index: true, element: <EntitiesList/>},
                    {path: ":entityId", element: <EntityDetailPage/>},
                ],
            },
            {path: "help", element: <HelpPage/>},
            {
                path: "feed",
                element: <FeedsPage/>,
                children: [
                    {
                        path: ":feedId", element: <FeedItems/>,
                        children: [
                            {path: ":sourceSegmentId", element: <ReadbookPage/>},
                        ],
                    },],
            },
        ],
    },
    {
        path: "/products/:reportId",
        element: <ReportPageLayout/>,
        children: [
            {path: "edit", element: <ReportEditorPage/>},
            {path: "mentions", element: <ReportMentionsPage/>},
            {path: "preview", element: <ReportPreviewPage/>},
        ],
    },
    {
        path: "/charts/:whiteboardId",
        element: <WhiteboardPage/>,
    },
    {path: "/whiteboards", element: <Navigate to="/charts" replace/>},
    {path: "/whiteboards/*", element: <LegacyWhiteboardRedirect/>},
    {path: "*", element: <Navigate to="/products" replace/>},
];

export function RoutesAnalyst() {
    const {role, roles} = useSession();
    const routesAnalyst = buildRoutesAnalyst(
        canAccessCollectionTab(role, roles) ? collectionChildRoutes : collectionDeepLinkRoutes,
    );
    return useRoutes(routesAnalyst);
}
